import { createContext, useContext, useState, useEffect, useRef } from 'react';
import { logout as apiLogout } from '../services/api';
import { UserData } from '../types/Api';
import { useUser } from './UserContext';

interface AuthContextType {
  userData: UserData | null;
  loading: boolean;
  checkAuth: () => Promise<UserData | null>;
  setLoggedIn: (value: boolean) => void;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { userData: userContextData, isLoading: userContextLoading, clearUserData } = useUser();
  const [userData, setUserData] = useState<UserData | null>(null);
  const [loading, setLoading] = useState(true);

  // UserContext'ten gelen verileri kullan
  useEffect(() => {
    if (!userContextLoading) {
      if (userContextData && userContextData.LoggedIn) {
        setUserData(userContextData);
      } else {
        setUserData(null);
      }
      setLoading(false);
    }
  }, [userContextData, userContextLoading]);

  const checkAuth = async () => {
    // UserContext verilerini kullan, gereksiz API çağrısını önle
    if (userContextData && userContextData.LoggedIn) {
      return userContextData;
    }
    return null;
  };

  const setLoggedIn = (value: boolean) => {
    if (!value) {
      setUserData(null);
    }
  };

  const logout = async () => {
    // Hemen tüm state'leri temizle
    setUserData(null);
    setLoading(false);
    clearUserData(); // UserContext'i de temizle
    
    // API logout'u background'da yap
    try {
      await apiLogout();
    } catch (error) {
      console.error('Logout error:', error);
      // Hata olsa da local state zaten temizlendi
    }
  };

  // İlk auth kontrolü için useEffect kaldırıldı
  // Artık UserContext'i kullanıyoruz

  return (
    <AuthContext.Provider value={{ userData, loading, checkAuth, setLoggedIn, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
} 